<template>
    <router-link
        tag="button"
        class="a-nav-button nav-button"
        :to="to"
        @click.native="onRedirect"
    >
        <span>{{ text }}</span>
        <svg-icon
            v-if="icon"
            original
            class="nav-button__icon"
            :name="`icons/${icon}`"
        />
    </router-link>
</template>

<script>
import '../../../assets/images/generated-svg';

export default {
    name: "ANavButton",
    props: {
        params: {
            type: Object,
            default: () => {}
        },
        to: {
            type: [String,Object],
            default: '/'
        },
        text: {
            type: String,
            default: 'text'
        },
        icon: {
            type: String,
            default: null
        }
    },
    methods: {
        onRedirect() {
            this.$emit('onRedirect', true)
        }
    }
}
</script>

<style lang="scss">
@import "a-nav-button.scss";
</style>
